import { useRecoilState } from "recoil";
import { ModalTypeState, SelectedScheduleState } from "../../atoms";
import { BaseModal } from "./BaseModal";
import { SchedulesClient } from "../../services";
import { GetNewInstance } from "../../helpers/HttpCommon";
import { ModalTypes } from "./ModalTypes";
import { useState } from "react";
import { Store } from "../../helpers";
import { toast } from "react-toastify";
import { SpinnerButton } from "../buttons";

type Props = {
  onSuccess: () => void;
  onFailure?: () => void;
};

export function DeleteSchedulModal({ onSuccess, onFailure }: Props) {
  const [, setModalType] = useRecoilState(ModalTypeState);
  const [selectedSchedule] = useRecoilState(SelectedScheduleState);
  const [showSpinner, setShowSpinner] = useState(false);

  const client = new SchedulesClient(undefined, GetNewInstance());
  const usersCustomerId = Store.getCustomerId();

  const onCancel = () => {
    setModalType(null);
  };

  const onDeleteClick = () => {
    if (usersCustomerId && selectedSchedule?.id) {
      setShowSpinner(true);
      client
        .deleteSchedule(usersCustomerId, selectedSchedule?.id)
        .then((response) => {
          toast.success("Schedule deleted successfully");
          setModalType(null);
          onSuccess();
        })
        .finally(() => {
          setShowSpinner(false);
        });
    }
  };

  return (
    <BaseModal
      id={ModalTypes.DeleteSchedulModal}
      title="Delete schedule"
      description={
        "Are you sure you want to delete the " +
        selectedSchedule?.name +
        " schedule?"
      }
    >
      <div className="py-4 text-sm text-white">
        <div className="mt-8 flex justify-end gap-4">
          <button
            onClick={onCancel}
            className="py-2.5 px-4 rounded-md border border-page-border bg-white bg-opacity-5 hover:bg-opacity-10"
          >
            Cancel
          </button>
          <SpinnerButton
            onClick={onDeleteClick}
            className="py-2.5 px-4 rounded-md bg-button-bg-destructive-default hover:bg-button-bg-destructive-hover active:shadow-button-bg-destructive-default"
            showSpinner={showSpinner}
          >
            Delete
          </SpinnerButton>
        </div>
      </div>
    </BaseModal>
  );
}
